<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Scientific Publications" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Publication</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div> 

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectedCategory">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedCategory" :options="formattedCategory"></b-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="publication_list" :fields="tablefields"  :per-page="perPage" >
                                    <template #cell(index)="data">
                                        <div style="width: 50px;">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <div>
                                            <img :src="host+row.item.image" alt="" style="height: 100px;">
                                        </div>
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 800px;">
                                            <a :href="row.item.link" target="_blank" class="link-style">
                                                <p>{{ row.item.title }}</p>
                                            </a>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletePublication(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editPublication(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- BLog Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Publication" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter publication title" v-model="publication.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Role</label>
                        <select class="form-control digits" v-model="publication.role">
                            <option v-for="(type, index) in role" :key="index" :value="type.value">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Year</label>
                        <select class="form-control digits" v-model="publication.year">
                            <option v-for="(type, index) in years" :key="index" :value="type.name">{{ type.name }}</option>
                        </select>
                        <!-- <b-form-datepicker v-model="date" :date-format="yearFormat" :min="minYear" :max="maxYear" :start-year="currentYear" :end-year="currentYear + 10" no-close-on-select :show-decade-nav="true" hide-header hide-header-divider @input="updateYear"></b-form-datepicker> -->
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="publication.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="publication.link">
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" placeholder="Enter description..." v-model="publication.description"></ckeditor>
                    </div>
                </div>
            </div> -->

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="height: 100px;" :src="show_image">
                            <input :class="publication.image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Publication Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Publication" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">   
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter publication title" v-model="edit_publication.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Role</label>
                        <select class="form-control digits" v-model="edit_publication.role">
                            <option v-for="(type, index) in role" :key="index" :value="type.value">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Year</label>
                        <select class="form-control digits" v-model="edit_publication.year">
                            <option v-for="(type, index) in years" :key="index" :value="type.name">{{ type.name }}</option>
                        </select>
                        <!-- <b-form-datepicker v-model="date" :date-format="yearFormat" :min="minYear" :max="maxYear" :start-year="currentYear" :end-year="currentYear + 10" no-close-on-select :show-decade-nav="true" hide-header hide-header-divider @input="updateYear"></b-form-datepicker> -->
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_publication.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="edit_publication.link">
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" placeholder="Enter description..." v-model="edit_publication.description"></ckeditor>
                    </div>
                </div>
            </div> -->

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="height: 100px;" :src="show_image">
                            <input :class="edit_publication.image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="EdituploadFile">
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this publication?</div>
    </b-modal>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import js from '../../../auth/js';
import loader from '../loader/loader.vue';

export default {
    components: {
        Datepicker,
        loader
    },

    data() {
        return {
            currentYear: new Date().getFullYear(),
            minYear: "1900",
            maxYear: "2100",
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            publication: {
                title: '',
                year: null,
                role: '',
                image: null,
                description: 'n/a',
                category: '',
                link:''
            },

            edit_publication: {
                id: '',
                title: '',
                year: null,
                role: '',
                image: null,
                description: 'n/a',
                category: '',
                link:''
            },

            role: [
                {
                    id: 1,
                    name: 'First Author',
                    value:'FIRST'
                }, 
                {
                    id: 2,
                    name: 'Co-Author',
                    value:'SECOND'
                }
            ],
           
            date:null,
            show_image: null,
            filterShow: false,
            selectedCategory:'',
            delete_value: null,
            initialLoad:true,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            years: Array.from({
                length: 2028 - 2000 + 1
            }, (v, k) => ({
                id: k + 1,
                name: (2028 - k).toString()
            })),
        };
    },

    computed: {
        ...mapState({
            publication_list: state => state.publication.publication,
            categories: state => state.publication.publication_category,
            count: state => state.publication.publication_count,
            loading: state => state.publication.publicationLoading,
            error: state => state.publication.publicationError
        }),

        formattedCategory() {
            return [
                {
                    value: '',
                    text: 'Select Category',
                    disabled: true
                },
                ...this.categories.map(category => ({
                    value: category.id,
                    text: category.title
                }))
            ];
           
        },

        yearFormat() {
            return "yyyy-MM-dd";
        },

        sortOptions() {
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    watch:{
        filter(newVal, oldVal) {
            this.$store.dispatch("publication/fetchPublication", {
                perPage: this.perPage,
                currentPage: 1,
                search_term: this.filter,
                category:this.selectedCategory
            }).then(() => {
                this.currentPage = 1
                this.totalRows = this.count;
            });
        },

        selectedCategory(newVal, oldVal) {
            this.$store.dispatch("publication/fetchPublication", {
                perPage: this.perPage,
                currentPage: 1,
                search_term: this.filter,
                category:this.selectedCategory
            }).then(() => {
                this.currentPage = 1
                this.totalRows = this.count;
            });
        },
        
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/admin-portfolio/publication',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    },
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("publication/fetchPublication", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    search_term: this.filter,
                    category:this.selectedCategory
                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/admin-portfolio/publication',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("publication/fetchPublication", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,
                    category:this.selectedCategory
                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        }
    },

    mounted() {
        this.$store.dispatch("publication/fetchPublicationCategory")

        if (!this.$route.query.page || !this.$route.query.perPage) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: this.currentPage,
                    perPage: this.perPage,
                },
            });

            this.$store.dispatch("publication/fetchPublication", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                category:this.selectedCategory
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false
            });
        } else {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: this.$route.query.page,
                    perPage: this.$route.query.perPage
                }
            });
            this.currentPage = this.$route.query.page
            this.perPage = this.$route.query.perPage

            this.$store.dispatch("publication/fetchPublication", {
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter,
                category:this.selectedCategory
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false
            });
        }
    },

    methods: {
        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.selectedCategory = ''
        },
        updateYear(selectedDate) {
            if (selectedDate) {
                this.publication.year = selectedDate.slice(0, 4); 
                this.edit_publication.year = selectedDate.slice(0, 4); 
            } else {
                this.publication.year = null;
                this.edit_publication = null;
            }
        },

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.publication.image = e.target.result;
            };
        },

        EdituploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.edit_publication.image = e.target.result;
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    
        resetModal() {
            this.publication.title = null
            this.publication.year = null
            this.publication.role = null
            this.publication.description = null
            this.publication.category = null
            this.publication.link = null
            this.show_image = null
            this.publication.image = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("publication/addPublication", {
                publication: this.publication,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.publication.title = null
                    this.publication.year = null
                    this.publication.role = null
                    this.publication.description = 'n/a'
                    this.publication.category = null
                    this.publication.link = null
                    this.show_image = null  
                    this.publication.image = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editPublication(detail) {
            this.edit_publication.id = detail.id ? detail.id : null
            this.edit_publication.title = detail.title ? detail.title : null
            this.edit_publication.year = detail.year ? detail.year : null
            this.edit_publication.role = detail.role ? detail.role : null
            this.edit_publication.description = detail.description ? detail.description : null
            this.edit_publication.category = detail.category ? detail.category.id : null
            this.edit_publication.link = detail.link ? detail.link : null
            this.show_image = detail.image ? this.host + detail.image : null
        },

        resetEditModal() {
            this.edit_publication.title = null
            this.edit_publication.year = null
            this.edit_publication.role = null
            this.edit_publication.description = 'n/a'
            this.edit_publication.category = null
            this.edit_publication.link = null
            this.show_image = null
            this.edit_publication.image = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("publication/updatePublication", {
                id: this.edit_publication.id,
                publication: this.edit_publication,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_publication.title = null
                    this.edit_publication.year = null
                    this.edit_publication.role = null
                    this.edit_publication.description = 'n/a'
                    this.edit_publication.category = null
                    this.edit_publication.link = null
                    this.show_image = null
                    this.edit_publication.image = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deletePublication(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("publication/deletePublication", {
                delete: this.delete_value,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
